import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast/toast';

@Component({
  selector: 'nr-toaster',
  imports: [],
  templateUrl: './toaster.html',
  styleUrl: './toaster.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToasterComponent {
  private readonly toastService = inject(ToastService);
  readonly toasts = this.toastService.displayedToasts;

  onDismiss(toastId: string): void {
    this.toastService.remove(toastId);
  }
}
